import styled from 'styled-components';

export const FullHeightWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
`;

export const SpinnerWrapper = styled.div`
  position: absolute;
  top: calc(50vh - 40px);
  right: 0;
  left: 0;
`;
